import { Injectable } from '@angular/core';
import { Tag } from './tag';
import { ArcService } from './arc.service'
import { UtilsService } from './utils.service'
import { Observable }  from 'rxjs/Observable';
import { RuntimeService } from './runtime.service'
import { ProjectService } from './project.service'
import { Project } from './project'
 import {ExportParserService} from './export-parser.service'

@Injectable()
export class TagService {
  _noTagsMap = new Map<string, Tag>()
  exportTagsSet: Set<string>

  constructor(
    private arcs: ArcService,
    private rts: RuntimeService,
    private utils: UtilsService,
    private projects: ProjectService,
    private ep: ExportParserService
  ) {
    this.arcs.tags = this
    this.projects.tags = this
    this.rts.tags = this
    this.ep.tags = this
  }

  exportJSON() {
    let m = this.rts.currentProject.tagsMap
    let dct = {}
    this.exportTagsSet.forEach(x => {
        let tag = m.get(x)
        let items = []
        tag.taggedItems.forEach(x => items.push(this.utils.jsonRecordId(x)))
        dct[x] = [tag.title, items]
    })
    console.log(666, dct)
    return dct
  }

  get manual() {
    return new Tag(this, this.rts.currentProject, '_manual', 'Manual')
  }

  get noTags() {
    let t = this._noTagsMap.get(this.rts.currentProject.id)
    if (t)
      return t
    t = new Tag(this, this.rts.currentProject, '_noTags', 'No tags')
    this._noTagsMap.set(this.rts.currentProject.id, t)
    return t
  }

  isExportedTag(tag: Tag) {
    return this.exportTagsSet.has(tag.id)
  }

  switchExport(tag: Tag) {
    if (!this.exportTagsSet.delete(tag.id))
      this.exportTagsSet.add(tag.id)
    let obs = this.arcs.run({
      fun: 'saveExportedTags',
      projectId: tag.project.id,
      tags: Array.from(this.exportTagsSet)
    })
    obs.subscribe((resp) => {
      console.log(122333, resp)
    })
    return obs
  }

  newFromSaved(p: Project, params: Object) {
    new Tag(this, p, params['id'], params['title'] || '???', params['taggedItems'])
  }

  newTag() {
    let tid = this.utils.uniqueIdentifier
    if (!tid)
      return
    return new Tag(this, this.rts.currentProject, tid, '')
  }

  save(t: Tag): Observable<any> {
    t.isNew = false
    let obs = this.arcs.run({
      fun: 'saveTag',
      title: t.title,
      projectId: t.project.id,
      id: t.id,
      taggedItems: Array.from(t.taggedItems)
    })
    obs.subscribe((resp) => {
      //console.log(122333, resp)
    })
    return obs
  }

  delete(t: Tag): Observable<any> {
    let obs = this.arcs.run({
      fun: 'deleteTag',
      id: t.id
    })
    obs.subscribe((resp) => t.project.tagsMap.delete(t.id))
    return obs
  }

}



// WEBPACK FOOTER //
// ./src/app/tag.service.ts